
import { EventType } from '../enums/event-type.enum';
import { EventCategory } from '../enums/event-category.enum';
import { EventAction } from '../enums/event-action.enum';
import { ProductAnalytics } from './product-analytics.model';


interface ClickEvent {
  products: ProductAnalytics[];
}

interface EcommerceEvent {
  click: ClickEvent;
}

export class ProductGridEvent {
  constructor(
    public event: EventType,
    public eventCategory: EventCategory,
    public eventAction: EventAction,
    public eventLabel: string,
    public noInteraction: string,
    public ecommerce: EcommerceEvent) {
  }

  public static forClick(eventLabel: string, productAnalytics: ProductAnalytics): ProductGridEvent {
    this.overrideEmptyString(productAnalytics);

    return {
      event: EventType.ProductClick,
      eventAction: EventAction.Click,
      eventCategory: EventCategory.ProductGrid,
      eventLabel,
      noInteraction: '1',
      ecommerce: {
        click: {
          products: [productAnalytics]
        }
      }
    };
  }

  private static overrideEmptyString(productAnalytics: ProductAnalytics) {
    for (const property in productAnalytics) {
      if (productAnalytics[property] === '') {
        productAnalytics[property] = undefined;
      }
    }
  }
}
